import React from 'react';
import { services } from '../config/commonConfig';
import { FormattedMessage } from 'react-intl';

const Services = () => {
  return (
    <section id="services" className="section main-padding theme-blue-bg">
      <div className={'py-5'}>
        {/* Heading */}
        <div className="position-relative text-center mb-2 my-5 pt-4">
          <p className={'text-9 text-dark fw-600 w-100 text-start text-white'}>
            <FormattedMessage
              id="services-expertise"
              defaultMessage="Our Expertise"
            />
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row ">
          <div className="col-lg-11 mx-auto">
            <div className="row  mt-5">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          'featured-box-icon text-primary bg-gradient-info shadow-sm rounded service-icon'
                        }>
                        <i className={service.icon} />
                      </div>
                      <h3 className="text-white fs-3">
                        <FormattedMessage
                          id={service.nameKey}
                          defaultMessage="Our Expertise"
                        />
                      </h3>
                      <p className={'mb-0 text-white fs-5'}>
                        <FormattedMessage
                          id={service.descKey}
                          defaultMessage="Our Expertise"
                        />
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
